import { hasBaseBudget, hasBudgetIds } from 'hooks'
import { type BaseBudget, type Budget, type BudgetIds } from 'typings'

export type ParsedBudget = {
  baseBudget: BaseBudget | undefined
  budgetIds: BudgetIds | undefined
  isComplete: boolean
}

export const isBudgetComplete = (budget: Budget): boolean => {
  return hasBaseBudget(budget) && hasBudgetIds(budget)
}

export function parseBudget(budget: Budget | undefined): ParsedBudget {
  if (!budget) {
    return {
      baseBudget: undefined,
      budgetIds: undefined,
      isComplete: false,
    }
  }

  const baseBudget = hasBaseBudget(budget) ? budget : undefined
  const budgetIds = hasBudgetIds(budget) ? budget : undefined
  const isComplete = isBudgetComplete(budget)

  return {
    baseBudget,
    budgetIds,
    isComplete,
  }
}
